var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIconOptimized2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon flat-color",
    width: 798.86,
    height: 800,
    fill: "#000000",
    "data-name": "Flat Color",
    viewBox: "0 0 23.966 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0029 0 0 1.0029 -.035256 -.035306)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.125 0 0 1.125 -1.5171 -1.5161)",
    strokeWidth: 1.2669
  }, /*#__PURE__*/React.createElement("circle", {
    id: "primary",
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "m19.37 17.88a8 8 0 0 0-3.43-3.83 5 5 0 1 0-7.88 0 8 8 0 0 0-3.43 3.83 1 1 0 0 0 0.2 1.12 10 10 0 0 0 14.24 0.1l0.09-0.09a1 1 0 0 0 0.21-1.13z",
    fill: "#ae3335"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.983,
    cy: 12,
    rx: 11.236,
    ry: 11.252,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.4253
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconOptimized2);
export default __webpack_public_path__ + "static/media/user-icon-optimized-2.e4823d6acccd540598fb014b9ba72d52.svg";
export { ForwardRef as ReactComponent };